import { TagOption } from "widgets/ModuleTagsWidget/type";
import { create } from "zustand";

export type StudiosDataStore = {
  selectedStudios: TagOption[];
  setSelectedStudios: (selectedStudios: TagOption[]) => void;
  clearStudiosData: () => void;
};

export const useStudiosData = create<StudiosDataStore>((set) => ({
  selectedStudios: [],
  setSelectedStudios: (selectedStudios) => set({ selectedStudios }),
  clearStudiosData: () =>
    set({
      selectedStudios: [],
    }),
}));
